module.exports = __webpack_public_path__ + "img/trip-fuel-coaching-0.d76db384.svg";